import { Box, ScrollArea, SimpleGrid, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { FIELD_TYPES, type FieldCategory, type FieldType } from '../../../lib/form-field-types';
import { FieldPaletteTile } from './FieldPaletteTile';

export interface FieldPaletteProps {
  onAdd: (type: FieldType) => void;
}

const CATEGORIES: { key: FieldCategory; labelKey: string }[] = [
  { key: 'standard', labelKey: 'fieldEditor.paletteCategoryStandard' },
  { key: 'choices', labelKey: 'fieldEditor.paletteCategoryChoices' },
  { key: 'other', labelKey: 'fieldEditor.paletteCategoryOther' },
];

export function FieldPalette({ onAdd }: FieldPaletteProps) {
  const { t } = useTranslation();

  return (
    <ScrollArea h="100%" type="auto">
      <Stack gap="lg" p="md">
        {CATEGORIES.map((cat) => {
          const items = FIELD_TYPES.filter((m) => m.category === cat.key);
          if (items.length === 0) return null;
          return (
            <Box key={cat.key}>
              <Text
                size="xs"
                tt="uppercase"
                c="dimmed"
                fw={500}
                mb="xs"
                style={{ letterSpacing: '0.05em' }}
              >
                {t(cat.labelKey)}
              </Text>
              <SimpleGrid cols={2} spacing="xs">
                {items.map((meta) => (
                  <FieldPaletteTile key={meta.type} meta={meta} onClick={() => onAdd(meta.type)} />
                ))}
              </SimpleGrid>
            </Box>
          );
        })}
      </Stack>
    </ScrollArea>
  );
}
